import { Chip } from "@mui/material";
import { Status } from "../../enums/status.js";

function renderStatus(status) {
	const colors = {
		[Status.PROCESSED]: "success",
		[Status.PENDING]: "default",
		[Status.EXPIRED]: "warning",
		[Status.DECLINED]: "warning",
		[Status.WAITING]: "default",
		[Status.APPROVED]: "success",
	};

	return <Chip label={status} color={colors[status]} size="small" />;
}

export const columns = [
	{ field: "createdAt", headerName: "Date", flex: 1.5, minWidth: 175 },
	{ field: "from", headerName: "From", flex: 1.5, minWidth: 100 },
	{ field: "to", headerName: "To", flex: 1.5, minWidth: 100 },
	{ field: "network", headerName: "Network", flex: 1.5, minWidth: 75 },
	{ field: "cryptoCurrency", headerName: "Crypto", flex: 1.5, minWidth: 75 },
	{
		field: "status",
		headerName: "Status",
		flex: 0.5,
		minWidth: 100,
		renderCell: (params) => renderStatus(params.value),
	},
	{ field: "cryptoAmount", headerName: "Amount", flex: 1.5, minWidth: 75 },
	{ field: "currencyAmount", headerName: "USD", flex: 1.5, minWidth: 75 },
	{ field: "fees", headerName: "Fees", flex: 1.5, minWidth: 75 },
	{ field: "total", headerName: "Total", flex: 1.5, minWidth: 75 },
	{ field: "documentId", headerName: "Document Id", flex: 1.5, minWidth: 75 },
];
